import { render, staticRenderFns } from "./pre_agreement.vue?vue&type=template&id=fd013280"
import script from "./pre_agreement.vue?vue&type=script&lang=js"
export * from "./pre_agreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports